import React, { useState } from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useGetTicketPrioritySlReportQuery } from "../../../../Services/reports/tickets/ReportTickets";
import TicketSlReportShell from "./TicketSlReportShell";
import {
  buildSingleOrMultiParam,
  MenuProps,
  PRIORITY_FILTER_OPTIONS,
  toApiPriority,
  toggleMultiSelect,
} from "./ticketSlReportUtils";

const TicketPrioritySlReport = () => {
  const [params, setParams] = useState<Record<string, string | number> | null>(
    null,
  );
  const [selectedPriorities, setSelectedPriorities] = useState<string[]>([]);

  const {
    data: reportData,
    isLoading: reportLoading,
    isFetching: reportFetching,
    isError,
    error,
    refetch,
  } = useGetTicketPrioritySlReportQuery(params, { skip: !params });

  const isAllPrioritiesSelected =
    selectedPriorities.length === PRIORITY_FILTER_OPTIONS.length;

  const buildExtraParams = () =>
    buildSingleOrMultiParam(
      selectedPriorities,
      PRIORITY_FILTER_OPTIONS,
      "priority",
      "priorities",
      toApiPriority,
    );

  const extraFilters = (
    <div className="w-100 mw-200px">
      <FormControl fullWidth>
        <InputLabel id="priority-select-label">Priority</InputLabel>
        <Select
          labelId="priority-select-label"
          multiple
          value={selectedPriorities}
          input={<OutlinedInput label="Priority" />}
          renderValue={(selected) =>
            isAllPrioritiesSelected || selected.length === 0 ? (
              <div>All</div>
            ) : (
              <div>{selected.join(", ")}</div>
            )
          }
          MenuProps={MenuProps}
        >
          <MenuItem
            value="all"
            onClick={(e) => {
              e.preventDefault();
              toggleMultiSelect(
                "all",
                setSelectedPriorities,
                PRIORITY_FILTER_OPTIONS,
              );
            }}
          >
            <Checkbox
              checked={isAllPrioritiesSelected}
              indeterminate={
                selectedPriorities.length > 0 && !isAllPrioritiesSelected
              }
            />
            <ListItemText primary="All" />
          </MenuItem>
          {PRIORITY_FILTER_OPTIONS.map((priority) => (
            <MenuItem
              key={priority}
              value={priority}
              onClick={(e) => {
                e.preventDefault();
                toggleMultiSelect(
                  priority,
                  setSelectedPriorities,
                  PRIORITY_FILTER_OPTIONS,
                );
              }}
            >
              <Checkbox checked={selectedPriorities.includes(priority)} />
              <ListItemText primary={priority} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );

  return (
    <TicketSlReportShell
      title="Priority SL"
      downloadFileName="Ticket_Priority_SL_Report"
      errorMessage="Failed to fetch Priority SL report"
      reportData={reportData}
      reportLoading={reportLoading}
      reportFetching={reportFetching}
      isError={isError}
      error={error}
      refetch={refetch}
      params={params}
      setParams={setParams}
      buildExtraParams={buildExtraParams}
      extraFilters={extraFilters}
      onResetExtra={() => setSelectedPriorities([])}
    />
  );
};

export default TicketPrioritySlReport;
